<template>
  <div v-if="user" class="w-full h-full flex flex-col relative">
    <nav
      class="flex justify-between px-6 h-16 fixed left-0 right-0 top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-primary-100 shadow-soft"
    >
      <div class="flex space-x-4 sm:space-x-12 items-center">
        <router-link
          :to="{ name: 'home' }"
          class="button-interactive hover:opacity-75"
        >
          <logo-icon class="w-20" />
        </router-link>
        <button
          class="rounded-full w-6 button-interactive"
          @click="collapsed = !collapsed"
        >
          <menu-icon class="w-full stroke-current fill-current" />
        </button>
      </div>

      <div class="flex items-center space-x-4">
        <router-link
          v-if="hasPermission('view_notifications')"
          :to="{ name: 'notifications' }"
          class="button-interactive rounded-full items-center flex hover:opacity-80"
          :class="[{ 'text-primary-500': selectedTab === 'notifications' }]"
        >
          <p
            v-if="user.pending_notifications_count > 0"
            class="text-success-500 font-medium"
          >
            {{ user.pending_notifications_count }}
          </p>
          <bell-icon class="w-6 h-6 stroke-current" />
        </router-link>

        <div class="flex flex-col">
          <p class="text-xs text-right font-medium">
            {{ user.email }}
          </p>
          <div class="w-full flex justify-end mt-1">
            <button
              class="text-xs w-fit system-button"
              @click="$store.dispatch('logout')"
            >
              Cerrar Sesión
            </button>
          </div>
        </div>
      </div>
    </nav>
    <div class="flex w-full h-full pt-16 relative">
      <div
        class="flex flex-col flex-shrink-0 h-full py-4 fixed sm:static bg-white border-r border-primary-100 tabSlider z-40 overflow-auto"
        :class="[{ 'w-[240px] px-4': !collapsed }, { 'w-0': collapsed }]"
      >
        <transition name="tabs">
          <div v-show="!collapsed" class="flex flex-col">
            <router-link
              :to="{ name: 'home' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'home' }]"
            >
              <div v-show="selectedTab === 'home'" class="tabSelector"></div>
              <div class="flex items-center">
                <home-icon class="w-4 fill-current mr-2" />
                <span>Inicio</span>
              </div>
            </router-link>

            <!-- <router-link
              v-if="hasPermission('view_notifications')"
              :to="{ name: 'notifications' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'notifications' }]"
            >
              <div
                v-show="selectedTab === 'notifications'"
                class="tabSelector"
              ></div>
              <div class="flex items-center">
                <bell-icon class="w-4 fill-current mr-2" />
                <span>Notificaciones</span>
              </div>
            </router-link> -->

            <router-link
              v-if="hasPermission('view_admins')"
              :to="{ name: 'adminsIndex' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'admins' }]"
            >
              <div v-show="selectedTab === 'admins'" class="tabSelector"></div>
              <div class="flex items-center">
                <users-icon class="w-4 fill-current mr-2" />
                <span>Usuarios</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_roles')"
              :to="{ name: 'rolesIndex' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'roles' }]"
            >
              <div v-show="selectedTab === 'roles'" class="tabSelector"></div>
              <div class="flex items-center">
                <roles-icon class="w-4 fill-current mr-2" />
                <span>Roles</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_franchises')"
              :to="{ name: 'franchisesIndex' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'franchises' }]"
            >
              <div
                v-show="selectedTab === 'franchises'"
                class="tabSelector"
              ></div>
              <div class="flex items-center">
                <branch-icon class="w-4 fill-current mr-2" />
                <span>Franquicias</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_clients')"
              :to="{ name: 'clientsIndex' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'clients' }]"
            >
              <div v-show="selectedTab === 'clients'" class="tabSelector"></div>
              <div class="flex items-center">
                <clients-icon class="w-4 fill-current mr-2" />
                <span>Clientes</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_pets')"
              :to="{ name: 'petsIndex' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'pets' }]"
            >
              <div v-show="selectedTab === 'pets'" class="tabSelector"></div>
              <div class="flex items-center">
                <pets-icon class="w-4 fill-current mr-2" />
                <span>Mascotas</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_quote_requests')"
              :to="{ name: 'quoteRequestsIndex', query: { status: 'pending' } }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'quoteRequests' }]"
            >
              <div
                v-show="selectedTab === 'quoteRequests'"
                class="tabSelector"
              ></div>
              <div class="flex items-center">
                <quote-requests-icon class="w-4 fill-current mr-2" />
                <span>Solicitudes de Cotización</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_appointment_requests')"
              :to="{ name: 'appointmentRequestsIndex' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'appointmentRequests' }]"
            >
              <div
                v-show="selectedTab === 'appointmentRequests'"
                class="tabSelector"
              ></div>
              <div class="flex items-center">
                <appointments-icon class="w-4 fill-current mr-2" />
                <span>Citas con especialista</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_quotes')"
              :to="{ name: 'quotesIndex', query: { status: 'pending' } }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'quotes' }]"
            >
              <div v-show="selectedTab === 'quotes'" class="tabSelector"></div>
              <div class="flex items-center">
                <quotes-icon class="w-4 fill-current mr-2" />
                <span>Planes</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_quotes')"
              :to="{ name: 'paymentIssuesIndex' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'paymentIssues' }]"
            >
              <div v-show="selectedTab === 'paymentIssues'" class="tabSelector"></div>
              <div class="flex items-center">
                <accounting-icon class="w-4 fill-current mr-2" />
                <span>Problemas de Pago</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_orders')"
              :to="{ name: 'ordersIndex', query: { status: 'pending' } }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'orders' }]"
            >
              <div v-show="selectedTab === 'orders'" class="tabSelector"></div>
              <div class="flex items-center">
                <orders-icon class="w-4 fill-current mr-2" />
                <span>Órdenes</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_orders')"
              :to="{ name: 'productionScheduleIndex' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'productionSchedule' }]"
            >
              <div v-show="selectedTab === 'productionSchedule'" class="tabSelector"></div>
              <div class="flex items-center">
                <orders-icon class="w-4 fill-current mr-2" />
                <span>Programa Produccion</span>
              </div>
            </router-link>

            <!-- CAMBIO 2026-04-23: dashboard de auditoría de planes -->
            <router-link
              v-if="hasPermission('edit_quotes')"
              :to="{ name: 'auditPlans' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'audit' }]"
            >
              <div v-show="selectedTab === 'audit'" class="tabSelector"></div>
              <div class="flex items-center">
                <orders-icon class="w-4 fill-current mr-2" />
                <span>Auditoría</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_frequencies')"
              :to="{ name: 'frequenciesIndex' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'frequencies' }]"
            >
              <div v-show="selectedTab === 'frequencies'" class="tabSelector"></div>
              <div class="flex items-center">
                <plans-icon class="w-4 fill-current mr-2" />
                <span>Frecuencias</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_referral_settings')"
              :to="{ name: 'referralSettings' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'referralSettings' }]"
            >
              <div v-show="selectedTab === 'referralSettings'" class="tabSelector"></div>
              <div class="flex items-center">
                <clients-icon class="w-4 fill-current mr-2" />
                <span>Referidos</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_breeds')"
              :to="{ name: 'breedsIndex' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'breeds' }]"
            >
              <div v-show="selectedTab === 'breeds'" class="tabSelector"></div>
              <div class="flex items-center">
                <pets-icon class="w-4 fill-current mr-2" />
                <span>Razas</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_diet_categories')"
              :to="{ name: 'dietCategoriesIndex' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[
                { 'text-primary-500': selectedTab === 'dietCategories' },
              ]"
            >
              <div
                v-show="selectedTab === 'dietCategories'"
                class="tabSelector"
              ></div>
              <div class="flex items-center">
                <diet-category-icon class="w-4 fill-current mr-2" />
                <span>Alimentos</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_diet_templates')"
              :to="{ name: 'dietTemplatesIndex' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[
                { 'text-primary-500': selectedTab === 'dietTemplates' },
              ]"
            >
              <div
                v-show="selectedTab === 'dietTemplates'"
                class="tabSelector"
              ></div>
              <div class="flex items-center">
                <template-icon class="w-4 fill-current mr-2" />
                <span>Plantillas de Dietas</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_user_guide')"
              :to="{ name: 'manual' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'manual' }]"
            >
              <div v-show="selectedTab === 'manual'" class="tabSelector"></div>
              <div class="flex items-center">
                <manual-icon class="w-4 fill-current mr-2" />
                <span>Manual de Usuarios</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_store')"
              :to="{ name: 'store' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'store' }]"
            >
              <div v-show="selectedTab === 'store'" class="tabSelector"></div>
              <div class="flex items-center">
                <branch-icon class="w-4 fill-current mr-2" />
                <span>Tienda en línea</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_posts')"
              :to="{ name: 'posts' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'posts' }]"
            >
              <div v-show="selectedTab === 'posts'" class="tabSelector"></div>
              <div class="flex items-center">
                <template-icon class="w-4 fill-current mr-2" />
                <span>Novedades</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_product_orders')"
              :to="{ name: 'productOrders' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'productOrders' }]"
            >
              <div
                v-show="selectedTab === 'productOrders'"
                class="tabSelector"
              ></div>
              <div class="flex items-center">
                <orders-icon class="w-4 fill-current mr-2" />
                <span>Órdenes de Compra</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_accounting')"
              :to="{ name: 'accounting' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'accounting' }]"
            >
              <div
                v-show="selectedTab === 'accounting'"
                class="tabSelector"
              ></div>
              <div class="flex items-center">
                <accounting-icon class="w-4 fill-current mr-2" />
                <span>Contabilidad</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_reports')"
              :to="{ name: 'biweekly' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'reports' }]"
            >
              <div v-show="selectedTab === 'reports'" class="tabSelector"></div>
              <div class="flex items-center">
                <reports-icon class="w-4 fill-current mr-2" />
                <span>Reportes</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('view_admins')"
              :to="{ name: 'barfheroImport' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'reports' }]"
            >
              <div v-show="selectedTab === 'barfheroImport'" class="tabSelector"></div>
              <div class="flex items-center">
                <span>Barfhero Import</span>
              </div>
            </router-link>

            <router-link
              v-if="hasPermission('manage_emails')"
              :to="{ name: 'massEmails' }"
              class="button-interactive text-sm font-medium mt-2 py-2"
              :class="[{ 'text-primary-500': selectedTab === 'massEmails' }]"
            >
              <div v-show="selectedTab === 'massEmails'" class="tabSelector"></div>
              <div class="flex items-center">
                <email-icon class="w-4 fill-current mr-2" />
                <span>Emails Masivos</span>
              </div>
            </router-link>
          </div>
        </transition>
      </div>

      <div ref="contentScroll" class="flex-auto overflow-auto bg-background p-8">
        <app-breadcrumbs />
        <router-view class="" />
      </div>

      <scroll-top-button :target="scrollTarget" />
    </div>
  </div>
</template>

<script>
import ScrollTopButton from "@/components/ui/ScrollTopButton";
import LogoIcon from "@/icons/LogoIcon";
import BellIcon from "@/icons/BellIcon";
import CartIcon from "@/icons/CartIcon";
import AccountIcon from "@/icons/AccountIcon";
import MenuIcon from "@/icons/MenuIcon";
import ArrowIcon from "@/icons/ArrowIcon";
import PetsIcon from "@/icons/PetsIcon";
import BranchIcon from "@/icons/BranchIcon";
import ClientsIcon from "@/icons/ClientsIcon";
import HomeIcon from "@/icons/HomeIcon";
import PlansIcon from "@/icons/PlansIcon";
import DietCategoryIcon from "@/icons/DietCategoryIcon";
import TemplateIcon from "@/icons/TemplateIcon";
import QuotesIcon from "@/icons/QuotesIcon";
import QuoteRequestsIcon from "@/icons/QuoteRequestsIcon";
import AppointmentsIcon from "@/icons/AppointmentsIcon";
import ReportsIcon from "@/icons/ReportsIcon";
import EmailIcon from "@/icons/EmailIcon";
import RolesIcon from "@/icons/RolesIcon";
import UsersIcon from "@/icons/UsersIcon";
import OrdersIcon from "@/icons/OrdersIcon";
import AccountingIcon from "@/icons/AccountingIcon";
import ManualIcon from "@/icons/ManualIcon";
import AppBreadcrumbs from "@/components/AppBreadcrumbs";
import { mapState } from "vuex";
export default {
  name: "Dashboard",

  components: {
    ScrollTopButton,
    LogoIcon,
    BellIcon,
    CartIcon,
    AccountIcon,
    MenuIcon,
    ArrowIcon,
    PetsIcon,
    BranchIcon,
    ClientsIcon,
    HomeIcon,
    PlansIcon,
    DietCategoryIcon,
    TemplateIcon,
    QuotesIcon,
    QuoteRequestsIcon,
    AppointmentsIcon,
    ReportsIcon,
    EmailIcon,
    RolesIcon,
    UsersIcon,
    OrdersIcon,
    AccountingIcon,
    ManualIcon,
    AppBreadcrumbs,
  },

  data() {
    return {
      collapsed: false,
      // Ref del contenedor que scrollea, para el botón "volver arriba"
      // (los refs no son reactivos — se copia en mounted).
      scrollTarget: null,
    };
  },

  mounted() {
    this.scrollTarget = this.$refs.contentScroll || null;
  },

  watch: {
    // El layout entero es v-if="user": el ref no existe hasta que el usuario
    // carga.
    user(value) {
      if (value) {
        this.$nextTick(() => {
          this.scrollTarget = this.$refs.contentScroll || null;
        });
      }
    },
  },

  computed: {
    ...mapState({
      selectedTab: "selectedTab",
      user: "user",
    }),
  },
};
</script>

<style scoped>
.tabSlider {
  @apply transition-all transform duration-500 ease-in-out;
}

.tab {
  @apply my-1 py-1 pl-2 rounded-r-full;
}

.tabSelector {
  @apply absolute -left-4 top-0 right-0 bottom-0 bg-primary-100 rounded-r-full -z-10;
}

.tabs-enter-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
  transition-delay: 0.2s;
}

.tabs-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.tabs-enter-from,
.tabs-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}

.tabs-enter-to,
.tabs-leave-from {
  opacity: 1;
  transform: translateX(0);
}

.subTabs-enter-active,
.subTabs-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.subTabs-enter-from,
.subTabs-leave-to {
  opacity: 0;
  transform: translateY(-10px); /* Adjust the value as needed */
}

.subTabs-enter-to,
.subTabs-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>